import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const bio = {
  ENG: <>With 8+ years of film and commercial practice in productions of all sizes, I consider my work an ongoing search for new challenges and experiences.<br /><br />Bilingual, based in the San Francisco Bay Area.<br />Open to working anywhere.</>,
  ESP: <>Con más de 8 años de práctica en cine y publicidad en producciones de todo tamaño, considero mi trabajo una búsqueda constante de nuevos retos y experiencias.<br /><br />Bilingüe, con base en San Francisco.<br />Disponible para trabajar en donde sea.</>,
}

export default function Info({ lang }) {
  const [toggle, setToggle] = useState(false)

  return (
    <div
      className={`info ${toggle ? "info--open moreglassy" : "glassy"}`}
      onClick={!toggle ? () => setToggle(true) : undefined}
    >
      <div
        className="info__icon"
        style={{ textAlign: toggle ? "right" : "center", cursor: "pointer" }}
        onClick={toggle ? () => setToggle(false) : undefined}
      >
        <FontAwesomeIcon icon="fa-solid fa-info" />
      </div>
      <div className="info__content">
        <h1>Patricio Trejo-Lerdo</h1>
        <p>hi@mocoso.co</p>
        <img className="headshot" src="https://yt3.ggpht.com/ytc/AMLnZu8AbPT987abAUHY43z7m-nMqydLXaiOSNG0cUxUpw=s900-c-k-c0x00ffffff-no-rj" alt="Patricio Trejo-Lerdo" />
        {bio[lang] || bio.ENG}
      </div>
    </div>
  )
}
